import { render, staticRenderFns } from "./PhanHoiForm.vue?vue&type=template&id=500c3e14&"
import script from "./PhanHoiForm.vue?vue&type=script&lang=js&"
export * from "./PhanHoiForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports